var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.formatedDescription)+" "),(_vm.descriptionToLong)?_c('router-link',{staticClass:"text-primary",attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.$t('item.readOn')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }